import { render } from "./AdminEmailSidebar.vue?vue&type=template&id=6bcf75f7&scoped=true"
import script from "./AdminEmailSidebar.vue?vue&type=script&lang=js"
export * from "./AdminEmailSidebar.vue?vue&type=script&lang=js"

import "./AdminEmailSidebar.vue?vue&type=style&index=0&id=6bcf75f7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcf75f7"]])

export default __exports__